import type { LabelHTMLAttributes } from "react";
import { forwardRef } from "react";
import { cn } from "@/shared/utils/cn";

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

// Ported from the tracker LabelAdapter using a native label element
// (ux-design-guidelines field label: text-sm font-semibold text-gray-700).
export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { className, ...props },
  ref,
) {
  return (
    <label
      ref={ref}
      className={cn(
        "mb-2 block text-sm font-semibold leading-none text-gray-700 peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className,
      )}
      {...props}
    />
  );
});
